/**
 * For use in the browser, spawns a worker running a server.
 * The server reads and writes via a FileSystem API directory handle.
 * And uses simple messaging for networking.
 */

import EventEmitter from 'eventemitter3'
import { uuid } from '../core/utils'
import { readPacket } from '../core/packets'

export class BrowserServer {
  constructor({ dirHandle }) {
    this.dirHandle = dirHandle
    this.worker = new Worker(window.BROWSER_SERVER_WORKER_PATH)
    this.worker.onmessage = this.onWorkerMessage
    this.worker.onerror = this.onWorkerError
    this.send('init', { dirHandle })
    this.connections = {}
    this.ready = new Promise(resolve => {
      this.readyResolve = resolve
    })
  }

  connect(params, onPacket, onClose) {
    const id = uuid()
    const connection = {
      id,
      params,
      onPacket,
      onClose,
      send: packet => {
        this.send('packet', { connectionId: connection.id, packet })
      },
    }
    this.connections[connection.id] = connection
    this.send('connect', { id, params })
    return connection
  }

  send(name, data, transfers) {
    this.worker.postMessage({ name, data }, transfers)
  }

  onWorkerMessage = msg => {
    // console.log('BrowserServer.onWorkerMessage', msg)
    const { name, data } = msg.data
    if (name === 'ready') {
      this.readyResolve()
      this.readyResolve = null
    }
    if (name === 'packet') {
      this.connections[data.connectionId].onPacket(data.packet)
    }
  }

  onWorkerError = err => {
    console.error('BrowserServer.onWorkerError', err)
  }
}
